import { useEffect, useState } from "react";
import { FileUploader } from "../../../../common/components/fileUploader/fileUploader";
import { ApiClient, ApiClientType } from "../../../../clients/api-client";
import axios from "axios";
import { showToastError, showToastSuccess } from "../../../../common/toasters/toasterMessages";
import dayjs from "dayjs";

export default function InspectionDocuments(props) {
    const { inspectionDetails } = props.values;
    const [fileList, setFileList] = useState([]);
    const [imagesList, setImagesList] = useState([]);


    const isInUploadingState = (item) => {
        return item?.status === "uploading";
    };

    const convertToBackendMediaObject = (newFileList) => {
        const formattedFileList = [];
        newFileList?.forEach((ele) => {
            let fileObj = {};
            if (ele.status === "done" && ele.response?.data?.url) {
                fileObj = {
                    name: ele.name,
                    type: ele.type,
                    size: ele.size,
                    url: ele.response?.data?.url
                };
                formattedFileList.push(fileObj);
            } else if (ele.url !== "") {
                formattedFileList.push(ele);
            }
        });
        return {
            media: formattedFileList
        };
    };

    const updateInspectionDetails = async (inspectionDetails, imagesList) => {
        const assigneesList = [];
        inspectionDetails?.qualityInspectionAssignees?.map(inspection =>
            assigneesList.push(inspection?.assigneeId)
        );
        const body = {
            supplierId: inspectionDetails?.supplier?.id,
            incomingPartId: inspectionDetails?.incomingPart?.id,
            invoiceNumber: inspectionDetails?.meta?.invoiceNumber,
            quantity: inspectionDetails?.quantity,
            deliveryDateTime: inspectionDetails?.meta?.deliveryDateTime ? dayjs(inspectionDetails?.meta?.deliveryDateTime) : '',
            samplingType: inspectionDetails?.samplingType,
            samplingNumber: inspectionDetails?.meta?.samplingDetails?.number,
            linkedSheets: inspectionDetails?.meta?.linkedSheets,
            assignees: assigneesList,
            dueDateTime: inspectionDetails?.dueDateTime ? dayjs(inspectionDetails?.dueDateTime) : '',
            media: imagesList?.[0]?.media
        };
        const response = await ApiClient(
            ApiClientType.patch,
            process.env.REACT_APP_MASTER_BASE_URL,
            `/incoming-quality-inspections/${inspectionDetails?.id}`,
            body
        );
        if (!response.isError) {
            showToastSuccess(response.displayableMessage);
        } else {
            showToastError(response.displayableMessage);
        }
    };

    const onChangeFileList = (newFileList) => {
        setFileList(newFileList);

        let isUploadingState = false;
        newFileList?.forEach((item) => {
            const isUploading = isInUploadingState(item);
            if (isUploading) {
                isUploadingState = true;
            }
        });
        if (isUploadingState) {
            return;
        }
        const metaObj = convertToBackendMediaObject(newFileList);
        setImagesList([metaObj]);
        void updateInspectionDetails(inspectionDetails, [metaObj]);
    };

    const fileUpload = async ({ file, onSuccess, onError }) => {
        const urlExtension = `/incoming-quality-inspections/${inspectionDetails?.id}/upload`;

        const response = await ApiClient(
            ApiClientType.post,
            process.env.REACT_APP_MASTER_BASE_URL,
            urlExtension,
            {}
        );

        if (!response.isError) {
            await axios
                .put(response?.data?.uploadLink?.url, file, {
                    headers: {
                        "Content-Type": file.type
                    }
                })
                .then((res) => {
                    onSuccess(response, file);
                })
                .catch((err) => {
                    onError(err, file);
                });
        } else {
            showToastError("Error in uploading media");
        }
    };

    useEffect(() => {
        setFileList(inspectionDetails?.meta?.media);
    }, [inspectionDetails])

    return (
        <>
            <FileUploader
                listType={"picture"}
                fileList={fileList}
                onChangeFileList={onChangeFileList}
                customRequest={fileUpload}
            />
        </>
    )
}